import { defineComponent as k, openBlock as a, createElementBlock as n, normalizeStyle as i, normalizeClass as f, createElementVNode as l, unref as v, toDisplayString as s, createCommentVNode as c, Fragment as d, createTextVNode as x, renderList as L, createVNode as w } from "vue";
import { useLandingAnimation as N } from "./index127.js";
import T from "./index60.js";
const C = ["id"], M = { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" }, S = {
  key: 0,
  class: "text-xs font-semibold uppercase tracking-widest",
  style: { color: "var(--landing-primary)" }
}, V = ["innerHTML"], H = ["innerHTML"], _ = { class: "mt-2 flex flex-col gap-3 sm:flex-row sm:gap-4" }, z = ["href", "target", "rel"], A = { class: "flex flex-col text-left" }, D = { class: "landing-cta-store-sub" }, E = { class: "landing-cta-store-main" }, $ = /* @__PURE__ */ k({
  __name: "LandingCTA",
  props: {
    overline: {},
    title: {},
    description: {},
    buttons: { default: () => [] },
    note: {},
    bg: { default: "light" },
    primary: { default: "var(--base-colors-primary-primary800)" },
    id: {}
  },
  setup(e) {
    const m = e, { el: y, isVisible: p } = N(), b = {
      "--landing-primary": m.primary,
      "--landing-dark": "var(--base-colors-neutral-neutral750)",
      "--landing-bg-light": "var(--base-colors-common-light-gray-f5)"
    }, o = () => m.bg === "dark", u = (r) => /^https?:\/\//.test(r);
    function g(r) {
      const t = r.label.toLowerCase().includes("app store");
      return {
        subLabel: t ? "Download on the" : "Get it on",
        iconName: t ? "apple-logo" : "play-store"
      };
    }
    return (r, h) => (a(), n("section", {
      id: e.id,
      class: f(["py-16 md:py-20 lg:py-24", o() ? "bg-[var(--base-colors-neutral-neutral750)]" : ""]),
      style: i([
        b,
        o() ? {} : { background: "var(--base-colors-common-light-gray-f5)" }
      ])
    }, [
      l("div", M, [
        l("div", {
          ref_key: "el",
          ref: y,
          class: f(["flex flex-col items-center gap-6 text-center transition-all duration-700", v(p) ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"])
        }, [
          e.overline ? (a(), n("span", S, s(e.overline), 1)) : c("", !0),
          l("h2", {
            class: "max-w-2xl text-3xl font-bold md:text-4xl lg:text-5xl",
            style: i({ color: o() ? "#fff" : "var(--landing-dark)" })
          }, [
            e.title.includes("<br />") ? (a(), n("span", {
              key: 0,
              innerHTML: e.title
            }, null, 8, V)) : (a(), n(d, { key: 1 }, [
              x(s(e.title), 1)
            ], 64))
          ], 4),
          e.description ? (a(), n("p", {
            key: 1,
            class: "max-w-lg text-base md:text-lg",
            style: i({
              color: o() ? "rgba(255,255,255,0.7)" : "var(--base-colors-neutral-neutral500)"
            })
          }, [
            e.description.includes("<br />") ? (a(), n("span", {
              key: 0,
              innerHTML: e.description
            }, null, 8, H)) : (a(), n(d, { key: 1 }, [
              x(s(e.description), 1)
            ], 64))
          ], 4)) : c("", !0),
          l("div", _, [
            (a(!0), n(d, null, L(e.buttons, (t) => (a(), n("a", {
              key: t.href,
              href: t.href,
              target: u(t.href) ? "_blank" : void 0,
              rel: u(t.href) ? "noopener noreferrer" : void 0,
              class: "landing-cta-store-btn inline-flex items-center gap-3 rounded-xl px-5 py-3 transition-all duration-200 ease-in-out active:scale-95"
            }, [
              w(T, {
                name: g(t).iconName,
                size: "lg"
              }, null, 8, ["name"]),
              l("span", A, [
                l("span", D, s(g(t).subLabel), 1),
                l("span", E, s(t.label), 1)
              ])
            ], 8, z))), 128))
          ]),
          e.note ? (a(), n("p", {
            key: 2,
            class: "text-sm",
            style: i({ color: o() ? "rgba(255,255,255,0.5)" : "#9ca3af" })
          }, s(e.note), 5)) : c("", !0)
        ], 2)
      ])
    ], 14, C));
  }
});
export {
  $ as default
};
